import React from 'react';
import './WhatsAppSupport.css';

const GenerateQuoteButton = () => {
  const quoteUrl = 'http://quotations.monarchinsurance.co.ke/';

  const handleClick = () => {
    window.open(quoteUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button 
      className="whatsapp-support-btn floating-btn floating-left quote-btn"
      onClick={handleClick}
      title="Generate a Quote"
      aria-label="Generate a Quote"
    >
      <span className="whatsapp-icon">📋</span>
      <span className="whatsapp-text">Generate Quote</span>
      <div className="pulse-ring"></div>
    </button>
  );
};

export default GenerateQuoteButton;
